<ng-template #toast>
  <div class="toast" [class.toast--error]="isErrorType" (mouseenter)="onHover()"
    (mouseleave)="onLeave()">
    <span *ngIf="isErrorType" class="k-icon k-i-warning"></span>
    <span *ngIf="!isErrorType" class="k-icon k-i-check-outline"></span>
    <p class="toast__message">{{ toastMessage }}</p>
    <button class="toast__close" (click)="onClose()"><span class="k-icon k-i-close"></span></button>
  </div>
</ng-template>